import * as S from './styles';
import { ProductCard } from "components/ProductCard";
import { useSessionStorage } from 'context/sessionStorage';
import { FooterWithButtons } from "pages/Checkin/components/FooterWithButtons";
import SelfieCapture from "pages/Checkin/components/SelfieCapture"
import { useGetFileFromSessionStorage } from 'pages/Checkin/hook/useGetFileFromSessionStorage';
import { useSaveFileToSessionStorage } from 'pages/Checkin/hook/useSaveFileToSessionStorage';
import { base64ToFile } from 'pages/Checkin/utils/base64ToFile';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useScreenWidth } from 'utils/useScreenWidth';

const check = require('assets/svg/checkin/Check.svg').default;
const camera = require('assets/svg/checkin/Camera.svg').default;
const invalid = require('assets/svg/checkin/Invalid.svg').default;
const warning = require('assets/svg/checkin/Warning.svg').default;
const trash = require('assets/svg/spaceUser/TrashRed.svg').default;

export const SelfieValidation = () => {
    const [selfiePreviewImage, setSelfiePreview] = useState<string | null>(null);
    const [selfieFile, setSelfieFile] = useState<File | null>(null);
    const [openModal, setOpenModal] = useState(false);
    const { t } = useTranslation();
    const [backPage, setBackPage] = useState<string>('');

    const isMobile = useScreenWidth();

    const handleCapture = (imageSrc: string) => {
        setSelfiePreview(imageSrc);
        // Aqui você pode também enviar a imagem para um servidor ou realizar outras ações necessárias
    };

    const saveFileToSessionStorage = useSaveFileToSessionStorage();
    const getFileFromSessionStorage = useGetFileFromSessionStorage();

    const { getFromSessionStorage } = useSessionStorage();

    useEffect(() => {

        const key = "document";
        const selfieFileName = "selfie";
        const selfieStorageImage = sessionStorage.getItem(selfieFileName);
        if (selfieStorageImage) {
            setSelfiePreview(selfieStorageImage);
        }
        getFileFromSessionStorage(key, selfieFileName).then(file => {
            if (file) {
                setSelfieFile(file);
            }
        });
        const dataPersonal = getFromSessionStorage('personal-info');
        if (dataPersonal) {
            if (dataPersonal.documentType === 'passport') {
                setBackPage('verify-passport');
            } else {
                setBackPage('verify-document');
            }
        }
    }, [getFileFromSessionStorage])


    const navigate = useNavigate();

    const pathnameActual: string = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));

    const handleDelete = () => {
        setSelfiePreview(null);
    }


    const handleContinue = () => {
        if (selfiePreviewImage) {
            base64ToFile(selfiePreviewImage, 'selfie').then((file) => {
                saveFileToSessionStorage('selfie', file);
                navigate(`${pathnameActual}/accompanying`);
            });
        }
    }

    const handleBack = () => {
        navigate(`${pathnameActual}/${backPage}`)
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }

    return (
        <S.SelfieValidationContainer>
            <h1>{t('checkin.selfieValidation.title')}</h1>
            <S.WarningMessage>
                <img src={warning} alt="" />
                <p>
                    {t('checkin.selfieValidation.warningMessage')}
                </p>
            </S.WarningMessage>
            <S.ContentSelfieValidation>
                <S.ContainerInputFile>
                    <strong>
                        {t('checkin.selfieValidation.takeASelfie')}
                    </strong>
                    {selfiePreviewImage ? (
                        <S.SelfiContainer>
                            <img src={selfiePreviewImage} alt="Selfie" />
                            <S.DeleteButton onClick={handleDelete}>
                                <img src={trash} alt="Delete" />
                            </S.DeleteButton>
                        </S.SelfiContainer>
                    ) : (
                        <S.InputFileSelfie onClick={handleOpenModal}>
                            <img src={camera} alt="" />
                            <p>{t('checkin.selfieValidation.inputSelfieText')}</p>
                        </S.InputFileSelfie>
                    )}
                </S.ContainerInputFile>
                <S.ColumnCheckSelfie>
                    <S.RowCheckSelfie>
                        <img src={check} alt="" />
                        <p>{t('checkin.selfieValidation.rules.takeASelfieNatural')}</p>
                    </S.RowCheckSelfie>
                    <S.RowCheckSelfie>
                        <img src={check} alt="" />
                        <p>{t('checkin.selfieValidation.rules.visivelFace')}</p>
                    </S.RowCheckSelfie>
                    <S.RowCheckSelfie>
                        <img src={check} alt="" />
                        <p>{t('checkin.selfieValidation.rules.takeASelfieNaturalLight')}</p>
                    </S.RowCheckSelfie>
                    <S.RowCheckSelfie>
                        <img src={invalid} alt="" />
                        <p>{t('checkin.selfieValidation.rules.noUseDocumentsPhotos')}</p>
                    </S.RowCheckSelfie>
                    <S.RowCheckSelfie>
                        <img src={invalid} alt="" />
                        <p>{t('checkin.selfieValidation.rules.takeASelfieWithout ThingsInYourFace')}</p>
                    </S.RowCheckSelfie>
                </S.ColumnCheckSelfie>
            </S.ContentSelfieValidation>
            <ProductCard isOpen={openModal} setIsOpen={setOpenModal} title="Tire uma selfie" bottomLine width={isMobile ? 'calc(100% - 40px)' : ''} >
                <SelfieCapture isModalOpen={openModal} onCapture={handleCapture} setIsOpenModal={setOpenModal} />
            </ProductCard>
            <FooterWithButtons handleBackStep={handleBack} handleNextStep={handleContinue} disableContinueButton={!selfiePreviewImage} />
        </S.SelfieValidationContainer>
    )
}